import { makeObservable, observable } from 'mobx';
import SituacaoAnalise, { SITUACAO_ANALISE } from '@/dominio/SituacaoAnalise';
import { Cancel, CheckCircleRounded } from '@mui/icons-material';
import TaskIcon from '@mui/icons-material/Task';
import { Filtro } from './Filtro';

export default class FiltroSituacaoAnalise extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Situação da análise';
    }

    getIconeFiltroRapido() {
        return <TaskIcon />;
    }

    opcoesFiltro = FiltroSituacaoAnalise.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_ANALISE.SEM_VALIDACAO.id,
                cor: SITUACAO_ANALISE.SEM_VALIDACAO.cor,
                icone: (
                    <Cancel style={{ fill: SITUACAO_ANALISE.SEM_VALIDACAO.cor, fillOpacity: '0.7', padding: '2px' }} />
                )
            },
            {
                valor: SITUACAO_ANALISE.VALIDADO.id,
                cor: SITUACAO_ANALISE.VALIDADO.cor,
                icone: (
                    <CheckCircleRounded
                        style={{ fill: SITUACAO_ANALISE.VALIDADO.cor, fillOpacity: '0.7', padding: '2px' }}
                    />
                )
            },
            {
                valor: SITUACAO_ANALISE.PENDENTE.id,
                cor: SITUACAO_ANALISE.PENDENTE.cor,
                icone: <Cancel style={{ fill: SITUACAO_ANALISE.PENDENTE.cor, fillOpacity: '0.7', padding: '2px' }} />
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        let valores = [];

        if (
            registro.informacaoProcessoSalaSessao.tipoValidacao &&
            registro.informacaoProcessoSalaSessao.tipoValidacao === SITUACAO_ANALISE.VALIDADO.id
        ) {
            valores.push(SITUACAO_ANALISE.VALIDADO.id);
        } else if (
            registro.informacaoProcessoSalaSessao.tipoValidacao &&
            registro.informacaoProcessoSalaSessao.tipoValidacao === SITUACAO_ANALISE.PENDENTE.id
        ) {
            valores.push(SITUACAO_ANALISE.PENDENTE.id);
        } else valores.push(SITUACAO_ANALISE.SEM_VALIDACAO.id);

        return valores;
    }

    getDescricao(valor) {
        return SituacaoAnalise.getDescricao(valor);
    }
}
